import moment from 'moment';

export const validate = (values) => { // eslint-disable-line
  const errors = {};


  if (!values.dataScadenza) {
    errors.dataScadenza = 'Obbligatorio';
  }
  if (values.dataScadenza) {
    if (+values.dataScadenza.format('X') < +moment.unix(new Date()).format('X') / 1000) {
      errors.dataScadenza = 'Documento scaduto';
    }
  }

  if (!values.dataEmissione) {
    errors.dataEmissione = 'Obbligatorio';
  }

  if (values.dataEmissione) {
    if (+values.dataEmissione.format('X') > +moment.unix(new Date()).format('X') / 1000) {
      errors.dataEmissione = 'Documento con data di emissione futura';
    }
  }

  if (values.dataEmissione && values.dataScadenza) {
    if (+values.dataEmissione.format('X') > +values.dataScadenza.format('X')) {
      errors.dataEmissione = 'La data di emissione è successiva a quella di scadenza';
    }
  }

  if (!values.numeroDocumento) {
    errors.numeroDocumento = 'Obbligatorio';
  }
  if (!values.ente) {
    errors.ente = 'Obbligatorio';
  }
  if ((!values.comune && !values.comuneNascita) || (!values.provincia && !values.provinciaNascita)) {
    errors.comune = 'Obbligatorio';
  }
  if (!values.tipoDocumento) {
    errors.tipoDocumento = 'Obbligatorio';
  }
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./app/components/Forms/DocumentoIdentita/validation.js